@if (!isUploadApprovals()) {
  <oct-sidenav
    [sidenavOpenedState]="sidenavOpenedState"
    [sidenavChangeState]="sidenavChangeState"
    [companyData]="company"
    [companies]="companies"
    [currentUser]="user()"
    [urlPrefix]="companyPrefix"
    (sidenavModeEmitter)="getSidenavState($event)"
    (emitSidenavOpenedState)="sidenavOpenedStateChange($event)"
    (emitSidenavChangeState)="sidenavStateChange($event)">
    <oct-menu [data]="menuList()" [isVisible]="isVisible" (menuChangeEmit)="menuOnChange($event)" />
    <div body class="container">
      <router-outlet />
    </div>
  </oct-sidenav>
} @else {
  <router-outlet />
}

@if (logout | async) {}
